<script>
    import _ from "lodash";

    import { sgettext } from '../../../i18n';
    import { isD2Enabled } from '../diffStore.js';

    import D2MetadataDiff from './D2MetadataDiff.svelte';
    import SummaryTable from './SummaryTable.svelte';
    import SummaryParentTable from './SummaryParentTable.svelte';

    export let reviewerSummary = null;
    export let controlOwnerSummary = null;
    export let strategyApproverSummary = null;
    export let activityApproverSummary = null;

</script>

<div class="header-container">
  <h4 class="mb-4">{sgettext('$$REVIEW_SUMMARY$$')}</h4>
  {#if $isD2Enabled}
    <D2MetadataDiff />
  {/if}
</div>

<div class="alert alert-info">
  <span style="font-size: 1.2rem; cursor: default;"
    ><i class="fa fa-info-circle mr-2" /></span
  >
  {sgettext('$$SELECT_CHANGE_LEFT$$')}
</div>

<br />

{#if reviewerSummary}
  <SummaryTable
    title={sgettext('$$CONTENT_AUTHOR_COMMENTS$$')}
    data={[
      {
        label: sgettext('$$REVIEW_REQUESTER$$'),
        value: `<a href="mailto:${reviewerSummary.review_requester}">${reviewerSummary.review_requester}</a>`,
      },
      {
        label: sgettext('$$REVIEW_REQUESTED_DATE$$'),
        value: reviewerSummary.review_requested_date,
      },
      {
        label: sgettext("$$S_NEW_VERSION$$"),
        value: reviewerSummary.whats_new,
      },
      {
        label: sgettext('$$AUTHOR_COMMENTS$$'),
        value: reviewerSummary.author_comments,
      },
      {
        label: sgettext('$$ATTACHMENTS$$'),
        value: reviewerSummary.attachments,
        attachment: true,
      },
    ]}
  />
{/if}

{#if controlOwnerSummary && controlOwnerSummary.length > 0}
  <SummaryParentTable
    title={sgettext('$$REVIEWER_COMMENTS$$')}
    subTables={controlOwnerSummary.map((summary) => ({
      title: summary.reviewer_type,
      data: [
        {
          label: sgettext('$$REVIEWER$$'),
          value: `<a href="mailto:${summary.reviewer}">${summary.reviewer}</a>`,
        },
        {
          label: sgettext('$$DATE$$'),
          value: summary.review_approved_date,
        },
        {
          label: sgettext('$$COMMENTS$$'),
          value: summary.reviewer_comments,
        },
      ],
    }))}
  />
{/if}

{#if strategyApproverSummary && strategyApproverSummary.length > 0}
  <SummaryParentTable
    title={sgettext('$$CONTROL_OWNER_COMMENTS$$')}
    subTables={strategyApproverSummary.map((summary) => ({
      title: summary.control_owner,
      data: [
        {
          label: sgettext('$$CONTROL_OWNER$$'),
          value: `<a href="mailto:${summary.control_owner}">${summary.control_owner}</a>`,
        },
        {
          label: sgettext('$$DATE$$'),
          value: summary.control_owner_approved_date,
        },
        {
          label: sgettext('$$COMMENTS$$'),
          value: summary.control_owner_comments,
        },
      ],
    }))}
  />
{/if}

{#if activityApproverSummary && !_.isEmpty(activityApproverSummary)}
  <SummaryTable
    title={sgettext('$$STRATEGY_APPROVER_COMMENTS$$')}
    data={[
      {
        label: sgettext('$$STRATEGY_APPROVER$$'),
        value: `<a href="mailto:${activityApproverSummary.strategy_approver}">${activityApproverSummary.strategy_approver}</a>`,
      },
      {
        label: sgettext('$$DATE$$'),
        value: activityApproverSummary.strategy_approved_date,
      },
      {
        label: sgettext('$$COMMENTS$$'),
        value: activityApproverSummary.strategy_approver_comments,
      },
    ]}
  />
{/if}

<style>
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
